import { defineNuxtRouteMiddleware, useRequestEvent } from '#imports'

import { updateActiveSpan } from '@backmarket/instrument/updateActiveSpan'
import { faro } from '@grafana/faro-web-sdk'
import { context } from '@opentelemetry/api'
import { RPCType, getRPCMetadata } from '@opentelemetry/core'

import { getRoutePath } from '../utils/getRoutePath'

/**
 * Per-route hook that updates downstream observability tooling with the
 * matched route name and metadata.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (process.server) {
    const event = useRequestEvent()
    if (!event) return

    const path = getRoutePath(to)
    const resource = `${event.node.req.method} ${path}`

    // Populate the RPCMetadata route so that @opentelemetry/instrumentation-http
    // attaches `http.route` to its metrics (e.g. http.server.request.duration).
    // The instrumentation only reads route from rpcMetadata — setting the span
    // attribute does not attach the data to the metric.
    const rpcMetadata = getRPCMetadata(context.active())
    if (rpcMetadata?.type === RPCType.HTTP) {
      rpcMetadata.route = path
    }

    updateActiveSpan((span) => {
      span.setAttributes({
        // dd legacy
        'resource.name': resource,
        'resource.locale': to.params?.locale ?? 'unknown',
        // otel
        'http.route': path,
      })
    })

    return
  }

  if (process.client && faro?.api) {
    const path = getRoutePath(to)
    faro.api.setView({ name: path })
  }
})
